export function previewId(previewId: string | undefined | false) {
  if (previewId) {
    return {
      'data-preview-id': previewId,
    };
  }
  return {};
}
